import React from 'react';
import MinusIcon from '../../assets/logo/MinusIcon';
import PlusIcon from '../../assets/logo/PlusIcon';

type ModifierToggleButtonProps = {
  quantity: number;
  isSelected: boolean;
  increase(): void;
  decrease(): void;
  isIncreasable: boolean;
};

const ModifierToggleButton = (props: ModifierToggleButtonProps) => {
  const { quantity, isSelected, increase, decrease, isIncreasable } = props;
  const hasDecreaseButton = isSelected;
  const hasIncreaseButton = isIncreasable;

  return (
    <>
      {hasDecreaseButton && (
        <button
          className={iconContainer}
          onClick={(e) => {
            e.stopPropagation();
            decrease();
          }}
          disabled={!isSelected}
        >
          <MinusIcon className="size-2" color="black" />
        </button>
      )}
      {!!quantity && <div>{quantity}</div>}
      {hasIncreaseButton && (
        <button
          className={iconContainer}
          onClick={(e) => {
            e.stopPropagation();
            increase();
          }}
        >
          <PlusIcon className="size-2" color="black" />
        </button>
      )}
    </>
  );
};

// TODO: add to custom colors
const iconContainer = 'w-6 h-6 bg-[#EEEEEE] rounded-full flex items-center justify-center';

export default ModifierToggleButton;
